import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Users, ArrowRight, Mail, Phone } from 'lucide-react';
import { Logo } from '../components/Logo';
import { WhatsAppButton } from '../components/WhatsAppButton';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Clients() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/clients`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClients(response.data);
    } catch (err) {
      console.error('Error fetching clients:', err);
    }
  };

  return (
    <div className="min-h-screen bg-sand" dir="rtl" lang="ar">
      <header className="bg-primary py-4 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-3">
          <button onClick={() => navigate('/dashboard')} data-testid="back-to-dashboard">
            <ArrowRight className="w-6 h-6 text-white" />
          </button>
          <Logo size="md" />
          <h1 className="text-2xl font-heading font-bold text-white">العملاء</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clients.map((client) => (
            <div
              key={client.id}
              className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover-lift"
              data-testid={`client-card-${client.id}`}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-heading font-semibold text-primary mb-2">
                    {client.full_name}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-600 mb-1">
                    <Mail className="w-4 h-4" />
                    <span className="font-body">{client.email}</span>
                  </div>
                  {client.phone && (
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <Phone className="w-4 h-4" />
                      <span className="font-body">{client.phone}</span>
                    </div>
                  )}
                  <p className="text-xs text-gray-500 mt-2 font-body">
                    تاريخ التسجيل:{' '}
                    {new Date(client.created_at).toLocaleDateString('ar-EG')}
                  </p>
                </div>
              </div>
              
              {/* أزرار التواصل */}
              <div className="flex gap-2 pt-3 border-t border-gray-100">
                <WhatsAppButton 
                  phoneNumber={client.phone}
                  clientName={client.full_name}
                  size="sm"
                  className="flex-1"
                />
                {client.phone && (
                  <a
                    href={`tel:${client.phone}`}
                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 text-xs bg-purple-100 text-purple-600 rounded-lg hover:bg-purple-200 transition-colors"
                  >
                    <Phone className="w-3 h-3" />
                    اتصال
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {clients.length === 0 && (
          <div className="text-center py-16" data-testid="no-clients">
            <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 font-body">لا يوجد عملاء حاليا</p>
          </div>
        )}
      </main>
    </div>
  );
}
